import {
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Validation } from '../../common/validation/validation';
import { InputFieldComponent } from '../input-field/input-field.component';
import { MultipleFileUploaderComponent } from '../multiple-file-uploader/multiple-file-uploader.component';
import { GlobalService } from '../../services/common/global.service';
import { Subscription } from 'rxjs';
import { CommonHttpsService } from '../../services/https/common-https.service';
import { ToasterMessageService } from '../../services/topbar-toaster/toaster-message.service';
import { LoaderService } from '../../services/loader/loader.service';
import { apiUrls } from '../../common/api_urls/api_urls';
import { CookieService } from 'ngx-cookie-service';
import { session } from '../../common/session/session';
import { AuthService } from '../../services/auth.service';
import { noWhitespaceValidator } from '../../helper/validtors-helper';
import { errorMessage } from '../../common/language/error';

@Component({
  selector: 'app-profile-setting-modal',
  imports: [
    ReactiveFormsModule,
    InputFieldComponent,
    MultipleFileUploaderComponent,
  ],
  templateUrl: './profile-setting-modal.component.html',
  styleUrl: './profile-setting-modal.component.css',
})
export class ProfileSettingModalComponent implements OnInit, OnDestroy {
   public errorMessage = errorMessage;
  private subscription: Subscription = new Subscription();
  public authService = inject(AuthService);

  ProfileSettingForm!: FormGroup;
  Validation = Validation;
  userSetting!: any;
  @Output() modalDismiss = new EventEmitter<void>();
  isNoImg: boolean = false;

  constructor(
    public fb: FormBuilder,
    private globalService: GlobalService,
    public commonHttpService: CommonHttpsService,
    public messageService: ToasterMessageService,
    public loadingService: LoaderService,
    public cookieService: CookieService,
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.userSetting = JSON.parse(this.globalService.getUserSettings());
    this.ProfileSettingForm = this.fb.group({
      id: [
        this.userSetting.userInfo.id,
        [Validators.required, noWhitespaceValidator],
      ],
      firstname: [
        this.userSetting.userInfo.first_name,
        [Validators.required, noWhitespaceValidator],
      ],
      lastname: [
        this.userSetting.userInfo.last_name,
        [Validators.required, noWhitespaceValidator],
      ],
      email: [
        this.userSetting.userInfo.email,
        [Validators.required, noWhitespaceValidator],
      ],
      logo: [
        this.userSetting.userInfo.imagePath,
        [Validators.required, noWhitespaceValidator],
      ],
      thumnnail: [this.userSetting.userInfo.thumbnail],
      imagePath: [this.userSetting.userInfo.imagePath],
      newImage: [''],
    });
  }

  onLogoRemove() {
    this.isNoImg = true;
  }

  onSubmit(): void {
    // if (this.ProfileSettingForm.valid) {
    this.loadingService.showSpinner();
    const newImage = this.ProfileSettingForm.value.newImage;
    const formData = new FormData();
    formData.append('Id', this.ProfileSettingForm.value.id);
    formData.append('First_name', this.ProfileSettingForm.value.firstname);
    formData.append('Last_name', this.ProfileSettingForm.value.lastname);
    formData.append('Email', this.ProfileSettingForm.value.email);
    if (newImage) {
      formData.append('image', newImage);
    } else {
      if (!this.isNoImg) {
        formData.append('thumbnail', this.ProfileSettingForm.value.thumnnail);
        formData.append('imagePath', this.ProfileSettingForm.value.imagePath);
      }
    }

    this.subscription.add(
      this.commonHttpService
        .UpdateEntity(apiUrls.user.updateUserProfile, formData)
        .subscribe({
          next: (res) => {
            this.loadingService.stopSpinner();
            this.messageService.successMessage(
              'Profile updated successfully',
              true,
            );
            this.authService.logout();
            this.closeModal();
          },
          error: (err) => {
            this.loadingService.stopSpinner();
            console.error('API Error:', err);
           this.messageService.errroMessage(
          this.errorMessage.ERRORMESSAGE,
          true,
         );
          },
        }),
    );
    // }
  }
  closeModal() {
    this.modalDismiss.emit();
  }

  onLogoChange(event: any) {
    const file = event.addedFiles[0];
    if (file) {
      this.ProfileSettingForm.patchValue({
        newImage: file,
      });
      if (file.size > 2 * 1024 * 1024) {
        alert('Error: File size exceeds the maximum limit of 2MB.');
        return;
      }
    }
  }
}
